import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./style.css";
import Home from "./pages/Home";
import Favorites from "./pages/Favorites";
import Cocktails from "./pages/Cocktails";
import SingleCocktail from "./pages/SingleCocktail";
import Error from "./components/Error";
import About from "./pages/About";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/cocktails" element={<Cocktails />} />
          <Route path="/about" element={<About />} />
          <Route path="/cocktails/:id" element={<SingleCocktail />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
